import { render, staticRenderFns } from "./DatenschutzText.vue?vue&type=template&id=532a9f8c&scoped=true&"
import script from "./DatenschutzText.vue?vue&type=script&lang=js&"
export * from "./DatenschutzText.vue?vue&type=script&lang=js&"
import style0 from "./DatenschutzText.vue?vue&type=style&index=0&id=532a9f8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532a9f8c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
